<template>
	<div class="auth-popup-holder" :class="popupType" :data-type="displayReg">
		<Loader v-if="showLoader" />
		<div class="auth-popup-main" >
			<div class="auth-popup-comp" id="auth-popup-list" :class="(!displayAuthValue) ? 'auth-form-max' : 'auth-form'">
				<Login  v-if="displayReg=='login'" 
					@updateAction="updateDisplay"
					@saveSuccess="toggleNotification"
					@updateAuthpopupComponent="updateAuthpopupComponent"  
					:displayMainConfPopup="(accessToken) ? true : false" 
					:displayValue="displayAuthValue"
					:savedAccessToken="accessToken"
					:parentUserId="userId"
					:parentEmailId="emailAddress"
					:contentData="contentData"
					:savedDrugs="savedDrugs"
					:isMobileDisplay="isMobileDisplay"
				/>
				<Register v-else-if="displayReg=='register'" 
					@updateAction="updateDisplay"
					@saveSuccess="toggleNotification"
					@updateAuthpopupComponent="updateAuthpopupComponent"  
					:displayMainConfPopup="(accessToken) ? true : false"
					:savedAccessToken="accessToken" 
					:displayValue="displayAuthValue"
					:parentUserId="userId"
					:parentEmailId="emailAddress"
					:contentData="contentData"
					:savedDrugs="savedDrugs"
					:isMobileDisplay="isMobileDisplay"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import api from './api.es6';
import axios from 'axios';
import Login from './components/Login.vue';
import Register from './components/Register.vue';
import SaveArticle from './components/SaveArticle.vue';
import ConfirmationOverlay from './components/ConfirmationOverlay.vue';
import registrationMixins from './components/mixins/registration.mixins.es6';
import CommonMixin from './components/mixins/commonapi.mixins.es6';
import Loader from './components/Loader.vue'
export default {
	props:{
		contentData:Object,
		popupType:String,
		savedDrugs: Object
	},
	created(){
		this.displayPopup = true
	},
	data(){
		return{
			showLoader : false,
			displayPopup :  true,
			displayAuth : null,
			displayAuthValue : false,
			accessToken : '',
			displayReg:  false,
			userId : '',
			emailAddress: '',
			isMobileDisplay:false,
		}
	},
	emits: ['updateAuthpopup', 'saveSuccess'],
	mixins: [registrationMixins, CommonMixin],
	components: {
		Login,
		Register,
		ConfirmationOverlay,
		SaveArticle,
		Loader
	},
	mounted(){
		if(this.popupType=='auth'){
			this.updateHolder(true);
		}
		if(this.popupType!='delete'){
			this.checkLogin()
			this.checkPopupType()
		}
		else{
			this.deleteDrugs(this.popupType);
		}
		this.isMobileDisplay = window.matchMedia('screen and (max-width: 992px)').matches;
	},
	unmounted(){
		this.updateHolder(false);
	},
	methods: {
		updateHolder(classStatus){
			if(classStatus){
				document.getElementsByTagName('body')[0].classList.add('remove-scroll')
			}
			else{
				document.getElementsByTagName('body')[0].classList.remove('remove-scroll')
			}
		},
		updateAuthpopupComponentCK(){
			if(this.displayPopup==true){
				this.displayPopup = false;
				this.updateHolder(false)
				this.$emit('updateAuthpopup', false, '', 'updateAuthpopupComponentCK')
			}
		},
		checkPopupType(){
			let getCookieData = this.getCookie('ab') 
			if(getCookieData && (getCookieData == 'b') && window.matchMedia('screen and (min-width: 993px)').matches){
				this.displayAuthValue = true;
			}
			else{
				this.displayAuthValue = false;
			}
		},
		updateDisplay(displayType='login'){
			// if(displayType!='login' && displayType!='register'){
			// 	window.location.reload()
			// }
			this.displayReg = displayType
		},
		toggleNotification(flag) {
			this.$emit('saveSuccess', flag);
		},
		updateAuthpopupComponent(popupStatus, pageName){
			if(this.displayPopup==true){
				this.displayPopup = false;
				this.updateHolder(false)
				this.$emit('updateAuthpopup', popupStatus, pageName, 'updateAuthpopupComponent')
			}
		},
		getCookie(cookieName) {
			let initName = cookieName + "=";
			let decodedWDCookie = decodeURIComponent(document.cookie);
			let wdCookie = decodedWDCookie.split(';');
			for(let initLoop = 0; initLoop <wdCookie.length; initLoop++) {
				let getCookie = wdCookie[initLoop];
				while (getCookie.charAt(0) == ' ') {
					getCookie = getCookie.substring(1);
				}
				if (getCookie.indexOf(initName) == 0) {
					return getCookie.substring(initName.length, getCookie.length);
				}
			}
			return "";
		},
		checkLogin(){
			let webmdAuth = this.getCookie('WBMD_AUTH');
			let webmdSauth = this.getCookie('WBMD_SAUTH');
			let webmdAuthp = this.getCookie('WBMD_AUTHP');
			if(webmdAuth && webmdSauth && webmdAuthp){
				this.accessToken = webmdAuthp;
				this.checkUser(webmdAuthp, false)
			}
			else{
				this.accessToken = ''
				this.displayReg = 'login'
				this.displayAuth = true;
			}
		},
		checkUser(authToken, loaderMain){
			let query = '/api/reg/regapi.svc/secure/json2/user';
			let searchapi = this.checkUrl('www',query);
			if((this.popupType!='bookmark' && this.popupType!='delete')){
				this.$vwmdPageLink({ moduleName: `reg-email-ver_refresh` });
			}
			if(loaderMain){
				this.showLoader = true;
			}
			api.getUserHeaders('', authToken).then(headers => axios.get(`${searchapi}`, headers, {credentials: 'include'})).then((response) => {
				this.userInfoRes = response.data;
				if(loaderMain){
					this.showLoader = false;
				}
				if (response.data.code == 1) {
					let userInfo = response.data.data.userinfo[0];
					if(userInfo && userInfo.emailVerifiedField!=1){
						this.userId = userInfo.userIdField;
						if(userInfo && userInfo.personField){
							this.emailAddress = userInfo.personField.emailAddressField
						}
						this.displayReg = 'login'
						this.displayAuth = true;
					}
					else{
						this.displayAuth = false;
						this.saveDrugs(this.contentData, authToken)
					}
				}
			}).catch((error) => {
				if(loaderMain){
					this.showLoader = false;
				}

			});
		},
		async saveDrugs(contentData, authToken, apiType='save'){
			let checkSave = await this.saveDrugsData(authToken, contentData, apiType, this.savedDrugs, false)
			// data will come on successfull save
			if(checkSave.data){
				this.displayReg = checkSave.popupType;
				if(this.displayReg === 'save') {
					this.$emit('saveSuccess', true);
				} else {
					this.$emit('saveSuccess', false);
				}
				this.updateAuthpopupComponent(false, 'saveddrugs');
			} else {
				this.showLoader = false;
				this.displayReg = '';
				this.updateAuthpopupComponent(false, 'saveddrugs');
			};
		},
		deleteDrugs(popupType){
			let webmdAuthp = this.getCookie('WBMD_AUTHP');
			if(webmdAuthp){
				this.saveDrugs(this.contentData, webmdAuthp, popupType)
			}
		},
		removeOverlay(){
			let getData = document.getElementsByClassName('v-modal');
			if(getData && getData.length){
				document.getElementsByClassName('v-modal')[0].remove()
			}

			let getHolderCLass = document.getElementsByClassName('webmd-popup-parent--hidden');
			if(getHolderCLass && getHolderCLass.length){
				document.getElementsByClassName('webmd-popup-parent--hidden')[0].classList.remove('webmd-popup-parent--hidden')
			}
		}
	},
};
</script>

<style lang="scss">
$font-family: "Source Sans Pro",Arial,sans-serif;
.auth-popup-holder{
	position: fixed;
	top:0px;
	z-index: 1000000;
	left:0px;
	width: 100%;
	height:100vh;
	.auth-spinner{
		z-index: 99999999;
		opacity: 0.8;
	}
	.auth-close{
		position: absolute;
		top: 30px;
		right: 30px;
		z-index: 9999999;
		img{
			width:31.67px;
			height:31.67px;
		}
		@media screen and (max-width:767px) {
			top: 22.5px;
			right: 22.5px;
			img{
				width:25px;
				height:25px;
			}
		}
	}
	.auth-popup-close{
		position: absolute;
		top: 30px;
		right: 30px;
		z-index: 99999999;
		img{
			width:31.67px;
			height:31.67px;
		}
		@media screen and (max-width:767px) {
			top: 22.5px;
			right: 22.5px;
			img{
				width:25px;
				height:25px;
			}
		}
	}
	.auth-popup-main{
		vertical-align: middle;
		position: relative;
		display: inline-block;
		width: 100%;
		-webkit-transform: translateY(-50%);
		transform: translateY(-50%);
		top: 50%;
		@media screen and (max-width:992px) {
			margin:0px 26px;
			width: calc(100% - 52px);
		}
		.auth-form-max{
			@media (min-width:992px) {
				max-width:600px;
				margin:0px auto;
				.auth-pages{
					min-height:600px;
				}
				.webmd-dialog{
					padding: 0px 40px;
				}
			}
		}
		.auth-form{
			@media (min-width:992px) {
				.auth-pages{
						min-height:600px;
				}
			}
		}
		.auth-pages {
			padding: 0;
			font-family: $font-family;
			display: flex;
			flex-wrap: wrap;
			z-index: 99999;
			max-width: 992px;
			position: relative;
			margin:0px auto;
			border-radius: 5px;
			overflow: hidden;
			@media screen and (max-width:992px) {
				max-width: 500px;
				padding: 0 !important;
				background: #f8f8f8;
			}
			@media screen and (max-width:767px) {
				max-width: 410px;
				padding: 0 !important;
				background: #f8fbf8;
			}
			.auth-close, .auth-popup-close{
				cursor: pointer;
			}
			.left-banner-section{
				flex-grow: 1;
				flex-basis: 50%;
				background-repeat: no-repeat;
				background-size: cover;
				background-position: top;
				background:#D2D9FF;
				padding: 126px 0px 130px 0px;
				box-shadow: 0px 0px 20px 2px rgba(204, 204, 231, 0.3);
				text-align: center;
				z-index: 9999;
				@media(max-width:992px){
					display: none !important;
				}
				.left-banner-images{
					text-align: left;
					display: inline-block;
					vertical-align: middle;
					max-width: 414px;
					margin:0px auto;
					margin-top: 0px;
					@media(max-width:992px){
						margin:30px 0 31px 0;
						padding: 0px 20px;
					}
					.section-holder{
						max-width: 367px;
						margin: 0px auto;
					}
					h3{
						font-size:18px;
						font-family: $font-family;
						font-weight: bold;
						margin-top:0px;
						margin-bottom:35px;
						line-height:30.8px;
						color:#000625 !important;
						text-align: center;
						@media(max-width:992px){
							text-align: center;
						}
					}
					ul{
						list-style: none;
						padding:0px;
						li{
							margin-bottom: 26.5px;
							font-size:18px;
							line-height:26px;
							&:last-child{
								margin-bottom:0px;
							}
							span.list-icon{
								background: #7384D8;
								width: 50px;
								height: 50px;
								border-radius: 50%;
								margin-right: 12px;
								display: inline-block;
								vertical-align: middle;
								position: relative;
								text-align: center;
								img, svg{
									max-width:30px;
									margin:0px auto;
									display: inline-block;
									vertical-align: middle;
									position: absolute;
									top: 50%;
									left: 50%;
									transform: translate(-50%, -50%);
								}
								svg {
									color: #00157C;
									path {
										stroke: #FFFFFF99;
									}
								}
							}
							span.list-text{
								display: inline-block;
								width:calc(100% - 80px);
								vertical-align: middle;
								color:#000625 !important;
								font-size: 16px;
								font-weight: 400;
								line-height: 25.6px;
							}
						}
					}
				}
			}
			.right-form-section{
				background:#f8f8f8;
				display: block;
				flex-grow: 1;
				flex-basis: 50%;
				text-align: center;
				.form-section{
					max-width: 410px;
					margin:0px auto !important;
					display: inline-block;
					vertical-align: middle;
					top: 50%;
					transform: translateY(-50%);
					width:100%;
					position: relative;
					.from-header{
						p{
							margin-bottom: 10px;
						}
					}
					h2{
						margin-top:0px;
						font-size:18px;
						font-family: $font-family;
						font-weight: bold;
						line-height: 28.8px;
						font-style: normal;
						color: #1B1B1B;
						text-align: center;
						@media(max-width:767px){
							padding: 0px 20px;
						}
					}
					p{
						font-size:16px;
						margin: 0 0 14px 0;
						line-height: 20.11px;
						font-weight: 400;
						a{
							color:#3557FF;
							text-decoration: underline;
							font-weight: 600;
						}
					}
					.form-account{
						margin-top:60px;
						p{
							margin:0px;
							color: #1B1B1B;
							font-weight: 400;
							font-size: 18px;
							line-height: 23px;
							a{
								color: #3557FF;
							}
						}
						@media(max-width:992px){
							margin-top:40px;
						}
						a{
							cursor: pointer;
						}
					}
					.text-error{
						text-align: left;
						color: #cb0606;
						font-size: 14px;
						font-family: $font-family;
						padding-top: 10px;
						span{
							a{
								color: #3557FF;
							}
						}
					}
					
					.form-button{
						margin: 0px;
						button{
							font-weight: 400;
							font-size: 24px;
							line-height: 50px;
							padding: 0;
							width:100%;
							background: #3557FF;
							border: 0px;
							text-align: center;
							letter-spacing: 0.05em;
							color: #FFFFFF;
							font-size: 20px;
							font-weight: 700;
							text-transform: capitalize;
							border-radius: 5px;
							cursor: pointer;
							span {
								a {
									color: white;
									text-decoration: none;
								}
							}
							@media(max-width:992px){
								font-weight: 600;
								font-size: 18px;
							}
						}
					}
					.form-checkbox{
						margin-top:0px;
						margin-bottom:0px;
						width:50%;
						display: inline-block;
						text-align: right;
						color:#333132;
						position: relative;
						.form-checkbox-holder{
							position: relative;
							
						}
						input[type="checkbox"]{
							top:-1px;
							position: relative;
							-webkit-appearance: none;
							appearance: none;
							border: 2px solid #CCCCE7;
							border-radius: 2px;
							width: 16px !important;
							height: 16px !important;
							padding:0px !important;
							border-radius: 2px !important;
							&:checked{
								background-color: #2196F3;
								border: 0px !important;
							}
						}
						label{
							margin-left:4px;
							font-size: 16px;
							font-weight: 400;
							line-height: 16px;
							color: #1B1B1B;
						}
						.checkmark {
							width: 16px;
							height: 16px;
							position: absolute;
							cursor: pointer;
							left: 0px;
							top: 1px;
							&:after {
								content: "";
								position: absolute;
								left: 6px;
								top: 0px;
								width: 5px;
								height: 10px;
								border: solid white;
								border-width: 0 3px 3px 0;
								-webkit-transform: rotate(45deg);
								-ms-transform: rotate(45deg);
								transform: rotate(45deg);
							}
						}
						svg{
							margin-right:2px;
						}
					}
					.from-body{
						.form-input-holder{
							position: relative;
							margin-bottom: 0;
							.form-input{
								position: relative;
							}
							.input-error{
								border:1px solid #cb0606;
							}
							.show-password{
								position: absolute;
								text-transform: uppercase;
								right: 0;
								color: #333132;
								font-weight: 600;
								font-size: 16px;
								line-height: 20px;
								top: 50%;
								right:13px;
								transform: translateY(-50%);
								cursor: pointer;
								font-family: $font-family;
							}
							input{
								height: 50px;
								width: 100%;
								border: 1px #CCCCE7 solid;
								border-radius: 3px;
								font-size:16px;
								color:#000;
								font-family: $font-family;
								outline: none;
								background: #fff;
								border-radius: 5px;

								&:active, &:focus{
									border:1px #0142F0 solid;
								}
								&:focus-visible{
									border:1px #0142F0 solid !important;
									outline: none;
								}
							}
							input:-webkit-autofill,
							input:-webkit-autofill:hover, 
							input:-webkit-autofill:focus, 
							input:-webkit-autofill:active{
								-webkit-box-shadow: 0 0 0 30px #fff inset !important;
							}
							input::-webkit-credentials-auto-fill-button {
								visibility: hidden;
								position: absolute;
								right: 0;
							}
							input:focus{
								padding: 22px 12px 5px 12px
							}
							input:focus + .placeholder-text .text, input.member-form-input:not(input[data-value=""]) + .placeholder-text .text{
								font-size:14px;
								color: #333132;
								transform: translate(0, -70%);
							}

							input:focus + .placeholder-text .text, div.webmd-date-editor--date:not(div[data-value=""]) + .placeholder-text .text{
								font-size:14px;
								color: #333132;
								transform: translate(0, -70%);
							}
							input:not(input[data-value=""]){
								padding: 22px 12px 5px 12px
							}

							div:not(input[data-value=""]) input{
								padding: 22px 12px 5px 12px
							}

							input:focus + .placeholder-text .text{
								border-color: #333132;
								color: #333132;
							}
							.placeholder-text{
								position: absolute;
								top: 0;
								bottom: 0;
								left: 0;
								right: 0;
								border: 3px solid transparent;
								background-color: transparent;
								pointer-events: none;
								display: flex;
								align-items: center;
							}
							.text{
								font-size: 16px;
								padding: 0;
								background-color: transparent;
								transform: translate(0);
								color: #616161;
								transition: transform 0.15s ease-out, font-size 0.15s ease-out, background-color 0.2s ease-out, color 0.15s ease-out;
							}
							input, .placeholder-text{
								font-size: 16px;
								padding: 15px 12px;
							}

							.placeholder-text{
								color: #616161;
							}
						}
						.form-text-holder{
							padding: 10px 0px 24px 0px;
							text-align: left;
							//height: auto;
							.form-text{
								width:50%;
								display: inline-block;
								a{
									color: #3557FF;
									text-decoration: underline;
									font-size: 16px;
									font-weight: 600;
									font-family: $font-family;
									line-height: 20px;
								}
							}
							.form-checkbox-content{
								display: inline-block;
								position: relative;
								vertical-align: middle;
								&:first-child{
									height:16px;
								}
							}
						}
					}
					.form-agree{
						text-align: left;
						font-family: $font-family;
						margin-bottom: 0px;
						color: #1B1B1B;
						a{
							color:#3557FF;
							text-decoration: underline;
						}
						@media(max-width:992px){
							margin-bottom:0px;
						}
						span{
							display: inline-block;
						}
					}
					@media (max-width:992px) {
						margin-top:0px;
					}
				}
				@media (max-width:992px) {
					width:100%;
					.from-header{
						margin-top:0px;
						p{
							margin-top:0px;
						}
					}
					.form-checkbox{
						margin-bottom: 0px !important;
					}
				}
				@media(max-width:980px) and (min-width:768px){
					padding:0px 30px;
				}
			}
		}
		.webmd-button--primary:disabled {
			background-color: #e8e6e6 !important;
			color: #767674 !important;
			cursor: not-allowed !important;
		}
	}
	
	.auth-popup-comp{
		z-index: 99999;
		max-width: 992px;
		position: relative;
		margin:0px auto;
		border-radius: 5px;
		overflow: hidden;
		@media screen and (max-width:992px) {
			max-width: 500px;
			padding: 0 !important;
		}
		@media screen and (max-width:767px) {
			max-width: 410px;
			padding: 0 !important;
		}
	}

	.profile-overlay > .webmd-dialog__wrapper >.webmd-dialog > .webmd-dialog__body{
		padding: 0;

		@media (max-width: 768px) {
			padding: 0 20px;
		}
		.overlay-cont {
		b {
			font-size: 20px;
		}

			p:nth-child(3), p:nth-child(4), p:nth-child(6)  {
				margin: 25px 0 0;
				@media (max-width: 768px) {
					margin: 20px 0 0;
					font-size:16px
				}
			}
			p:nth-child(5) {
				margin: 30px 0 0;
				@media (max-width: 768px) {
					margin: 25px 0 0;
				}
			}
			p:nth-child(7)  {
				margin: 25px 0 0;
				@media (max-width: 768px) {
					margin: 20px 0 0;
				}
			}
			p:nth-child(5),p:nth-child(7)  {
				font-size: 16px;
				@media (max-width: 768px) {
					font-size: 14px;
				}
			}
		}
	}
}
.remove-scroll{
	overflow: hidden;
}
.auth-spinner-main{
	background: #3C4159 !important;
	z-index: 99999999;
	opacity: 0.8;
}
.auth-popup-holder.auth{
	&:after{
		content: '';
		position: fixed;
		background: #3C4159;
		opacity: 0.9;
		top:0px;
		left:0px;
		width: 100%;
		height: 100%;
		z-index: -2;
	}
}
</style>
